var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__inner-content"},_vm._l((_vm.contentItems),function(contentItem,index){return _c(_vm.getComponent(contentItem._group),{key:index,tag:"component",attrs:{"contentItem":contentItem}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }